var _path, _path2, _rect, _path3, _rect2, _path4, _rect3, _rect4, _path5, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteinLadder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 86,
    viewBox: "0 0 40 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0408 85.5805C13.152 85.5805 11.7954 85.2544 11.0469 85.0215C10.2985 84.7885 9.69036 82.0865 9.69036 82.0865C7.72567 74.4462 5.0664 63.2041 5.00582 56.427C4.99383 55.0839 5.0058 29 5.0058 29H6.51004H23.0573V56.427C23.0573 63.427 19.9349 74.4462 17.9702 82.0865C17.9702 82.0865 17.362 84.7885 16.6136 85.0215C15.8651 85.2544 14.5086 85.5805 13.6198 85.5805",
    fill: "#868CA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M13.9863 84.6415C13.191 84.6415 11.9748 84.362 11.3199 84.1291C10.665 83.9427 10.1036 81.4736 10.1036 81.4736C8.32606 74.6253 6.52311 64.5288 6.00855 58.5191C6.00854 55.427 6.00854 32.6166 6.00854 32.6166V30.427H22.0543C22.0543 30.427 22.335 55.3512 22.0543 58.5191C21.5397 64.5288 19.319 74.5787 17.5414 81.427C17.5414 81.427 16.9801 83.8495 16.3252 84.0825C15.6703 84.2688 14.454 84.5949 13.6588 84.5949",
    fill: "#C0C3D2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 29,
    width: 23.0657,
    height: 2,
    fill: "#868CA6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13.9863 84.6415C13.191 84.6415 11.9748 84.3619 11.3199 84.129C10.665 83.9427 10.1036 81.4735 10.1036 81.4735C8.32606 74.6252 6.52311 64.5288 6.00854 58.519V55H14.5H22.0543V58.519C21.5397 64.5288 19.319 74.5786 17.5414 81.4269C17.5414 81.4269 16.9801 83.8495 16.3252 84.0824C15.6703 84.2688 14.454 84.5949 13.6588 84.5949",
    fill: "#00AEEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.00574,
    y: 37.427,
    width: 18.0515,
    height: 16,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0429 31H23.0572C23.0572 31 23.0572 54.5636 23.0572 57.5091C23.0572 60.4545 21.0515 69.7818 21.0515 69.7818C21.0515 69.7818 17.2595 84.2943 17.0401 84.5091C16.8207 84.7239 14.0315 85 14.0315 85L18.0429 57.5091V31Z",
    fill: "black",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.994263,
    y: 26,
    width: 26.0743,
    height: 2,
    fill: "#868CA6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.00854,
    y: 28,
    width: 16.0457,
    height: 1,
    fill: "#577898"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.749 27.123C29.9999 27.5453 30.0771 28.0262 30.0771 28.5C30.0771 28.9738 29.9999 29.4547 29.749 29.877C29.4837 30.3234 29.0915 30.5928 28.6742 30.7488C28.2836 30.8949 27.8525 30.9492 27.4445 30.9746C27.037 31 26.5719 31 26.0884 31H26.0657V29C26.5769 29 26.9811 28.9996 27.3194 28.9785C27.6635 28.9571 27.8592 28.9176 27.97 28.8762C27.9942 28.8671 28.0103 28.8594 28.0202 28.854C28.0229 28.8526 28.0252 28.8513 28.027 28.8502C28.028 28.8479 28.0292 28.8449 28.0306 28.8413C28.035 28.8297 28.0412 28.8107 28.0473 28.7824C28.06 28.7243 28.0714 28.6339 28.0714 28.5C28.0714 28.3661 28.06 28.2757 28.0473 28.2176C28.0412 28.1893 28.035 28.1703 28.0306 28.1587C28.0292 28.1551 28.028 28.1521 28.027 28.1498C28.0252 28.1487 28.0229 28.1474 28.0202 28.146C28.0103 28.1406 27.9942 28.1329 27.97 28.1238C27.8591 28.0824 27.6635 28.0429 27.3194 28.0215C26.9811 28.0004 26.5769 28 26.0657 28L26.0657 26L26.0884 26C26.5719 26 27.037 26 27.4445 26.0254C27.8525 26.0508 28.2836 26.1051 28.6742 26.2512C29.0915 26.4072 29.4837 26.6766 29.749 27.123Z",
    fill: "#868CA6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 40,
    width: 12,
    height: 2,
    fill: "#3E3E3E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 44,
    width: 12,
    height: 2,
    fill: "#3E3E3E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 48,
    width: 12,
    height: 2,
    fill: "#3E3E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinLadder);
export default __webpack_public_path__ + "static/media/proteinLadder.8119dda652620049443b98d45fd99d6f.svg";
export { ForwardRef as ReactComponent };